module.exports = __webpack_public_path__ + "img/yxj.2d1bc045.png";